<!--Router-outlet-->
<router-outlet></router-outlet>
<ngx-loading [show]="isLoading" id="loadingIcon"></ngx-loading>
<ng-template #dialogModal>
    <div class="dialog-modal" id="dialog-modal-message">
        <div class="modal-header">
            <h4 class="title-dialog modal-title pull-left">{{dialog?.title}}</h4>
        </div>
        <div class="modal-body">
            <div class="box-msg-mdh">
                <div>
                    <p style="word-break: break-word; white-space: pre-line;">{{dialog?.message}}</p>
                    <div style="text-align: center;" *ngIf="dialog?.checklabel !== '' ">
                        <label class=" custom-checkbox">{{dialog?.checklabel}}
                            <input class="custom-checkbox" type="checkbox" [(ngModel)]="checkValue" />
                            <span style="box-shadow:none" class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>


            <div class="text-right btn-div" *ngIf="dialog?.checklabel !== '' ">
                <button class="btn btn-ok" (click)="clickButtonOKCheckDialog()">
                    {{dialog?.checkBtn}}
                </button>
            </div>
            <div class="text-right btn-div" *ngIf="dialog?.cancelBtn && dialog?.noBtn">
                <button (click)="clickButtonCancel()" class="btn btn-cancel">
                    {{dialog?.cancelBtn}}
                </button>
                <button (click)="clickButtonNo()" class="btn btn-no">
                    {{dialog?.noBtn}}
                </button>
                <button class="btn btn-ok" (click)="clickButtonOK()">
                    {{dialog?.okBtn}}
                </button>
            </div>
            <div class="text-right btn-div" *ngIf="dialog?.cancelBtn && !dialog?.noBtn">
                <button (click)="clickButtonCancel()" class="btn btn-cancel">
                    {{dialog?.cancelBtn}}
                </button>
                <button class="btn btn-ok" (click)="clickButtonOK()">
                    {{dialog?.okBtn}}
                </button>
            </div>
            <div class="text-right btn-div" *ngIf="!dialog?.cancelBtn && !dialog?.noBtn && dialog?.okBtn">
                <button class="btn btn-ok" (click)="clickButtonOK()">
                    {{dialog?.okBtn}}
                </button>
            </div>
        </div>
    </div>
</ng-template>
